




























import Vue from 'vue'
import Checkbox from '../../../components/Checkbox.vue'

export default Vue.extend({
    props: ['domains', 'store'],
	components: {
		Checkbox
	},
    data() {
        return {
            value: this.store,
            toggle: false,
            cl: false,
            selector: '.dropdown.only-click ul'
        }
    },
    watch: {
        value() {
            if (!this.store.length) {
                this.store.push('general')
            }
            this.$emit('change', this.value)           
        }
    },
    mounted() {
        $(this.selector).on('click', this.stopProp)
        document.body.addEventListener('click', this.close)
    },
    destroyed() {
        $(this.selector).unbind('click', this.stopProp)
        document.body.removeEventListener('click', this.close)
    },
    computed: {
        text(): string {
            let index = this.store.indexOf('general')

            return index != -1 || !this.store.length ? 'Все домены' : 'Выбранные'
        }
    },
    methods: {
        close() {
            if (!this.cl) {
                this.toggle = false
            }
            this.cl = false
        },
        stopProp(e: Event) {
            e.stopPropagation();
        },
        toggleDomain(toggle: boolean, domain: string) {
            if (toggle) {
                this.addDomain(domain)
            }
            else {
                this.removeDomain(domain)
            }
        },
        addDomain(domain: string) {
            if (this.value.indexOf(domain) == -1) {
                this.value.push(domain)
            }
        },
        removeDomain(domain: string) {
            this.value = this.value.filter((item: string) => item != domain)
        }
    }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/notification/DropdownStore.vue